import {Circle} from '@react-google-maps/api'
import * as turf from '@turf/turf'
import {useEffect, useState} from 'react'
import {TRaio} from '../../../../inteligencia-mercado/components/Types'
import {CoordinatesToPath} from '../../../../../components/UI/MapView'
import {useImoveisStore} from '../../../context/DataContext'

const options = {
  fillColor: 'lightgreen',
  fillOpacity: 0.6,
  strokeColor: 'green',
  strokeOpacity: 1,
  strokeWeight: 1,
  clickable: true,
  draggable: false,
  editable: false,
  geodesic: false,
  zIndex: 1,
}

type Props = {
  lat: any
  lng: any
  map: any
  distancia: number
  finalidade?: string
}

function Raio({lat, lng, map, distancia, finalidade = 'venda'}: Props) {
  const [paths, setPaths] = useState<TRaio>(null)
  const {setGeometria, fetchData, filtro} = useImoveisStore()

  console.log('finalidade raio')
  console.log(finalidade)

  useEffect(() => {
    if (lat && lng && map && distancia) {
      console.log('finalidade')
      console.log(finalidade)
      loadRaio(map, lat, lng, distancia, finalidade)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lat, lng, distancia, map, filtro])

  async function loadRaio(
    map: any,
    lat: number,
    lng: number,
    distancia: number,
    finalidade: string
  ) {
    map.panTo(new google.maps.LatLng(lat, lng))
    map.setZoom(15)
    let coordinates = [lng, lat]
    var circle = turf.circle(coordinates, distancia, {units: 'meters'})
    let raio: TRaio = {
      geojson: circle,
      id: Math.random(),
      paths: CoordinatesToPath(circle.geometry.coordinates[0]),
      raio: Number(distancia),
      selected: false,
      editable: false,
    }
    setGeometria(circle)
    setPaths(raio)
    fetchData(circle, 'RAIO', finalidade)
    // loadImoveis(circle.geometry, 'raio')
  }

  if (paths) {
    let center = turf.center(paths.geojson)

    return (
      <>
        {paths ? (
          <Circle
            radius={distancia}
            center={{lat: center.geometry.coordinates[1], lng: center.geometry.coordinates[0]}}
            options={options}
          />
        ) : (
          ''
        )}
      </>
    )
  } else {
    return <></>
  }
}

export default Raio
